import { Component, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router, RouterLink } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../material.module';
import { Editor, NgxEditorComponent, NgxEditorMenuComponent, Toolbar } from 'ngx-editor';
import { toHTML, parseContent  } from 'ngx-editor';
import { BasicInformationDataShareService } from '../basic-information/basic-information-data-share.service';
import { CharitiesService } from '../charities/services/charities.service';
import { CommonModule, DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FinalAccountsapiService } from './final-accountsapi.service';
import { NotesDatashareService } from '../notes/services/notes-datashare.service';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import moment from 'moment';
import { ApprovalDetails } from '../../../Data/Models/Final Accounts/final-accountsmodel';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { BalanceSheetapiService } from '../balancesheet/balance-sheetapi.service';
import { BaseEntityModel } from '../../../Data/Models/Common/base-entity-model';
import { Email_Configuration_Model } from '../../../Data/Models/Email_Configuration_Model/Email_Configuration_Model';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { Email_Configuration_Service } from '../../../services/Email_Configuration_Service/Email_Configuration_Service';
import { SubmissionsapiService } from '../submissions/submissionsapi.service';
import { CharityDetailsModal } from '../charities/addcharities/CharityDetailsModal';
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddSpaceBeforeNumberPipe } from '../../../pipe/add-space-before-number.pipe';
import { List } from 'angular-feather/icons';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { MessageServiceService } from '../../../Shared/common/message-service.service';

@Component({
  selector: 'app-final-accounts',
  imports: [MaterialModule, TablerIconsModule, MatProgressBarModule, MatDatepickerModule, PdfJsViewerModule, NgxEditorComponent, NgxEditorMenuComponent, CommonModule, FormsModule, RouterLink, ReactiveFormsModule, TextMaskDateDirective, AddSpaceBeforeNumberPipe],
  templateUrl: './final-accounts.component.html',
  styleUrl: './final-accounts.component.scss',
    providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe]
})
export class FinalAccountsComponent implements OnInit {
  BalanceSheetStatus: any;
  TrailBalanceStatus: any;
  SOFAStatus: any;
  TrusteeAnnualReportStatus: any;
  AuditorStatus: any;
  IndependentExaminationStatus: any;
  StatementofTrusteesResponsibility:any
  mandatorycount: number = 5
  progress:number=0
  isdirty: boolean = false;
  editor1: Editor;
  previousValidHtml: string;
  notecompleted: boolean = true
  trusteecompleted: boolean = false
  statementoftrusteecompleted: boolean = false;
  Descriptionstring: any
  initialContent :any; // This will store the starting value
  contentChanged = false;
  private valueChangeSub!: Subscription;
  initialDoc: string;
  accounting_Method: any
  report_Type: any
  ApprovalForm!: FormGroup;
  displayedColumns: string[] = ['name', 'status', 'action'];
  approver: any[] = [
    { type: 'data', nameofapprover: 'Turnover', status: '', action: '' },
    { type: 'data', nameofapprover: 'Turnover', status: '', action: '' },
  ];
  startDate: any
  today: any = moment()
  trustee: any
  editor: Editor;
  RetriveEmailConfigdata: any;
  UserRoleAccess: RolesModel;
  exportForm: FormGroup
  CharityDetails: CharityDetailsModal[] = [];
  notesArray: any
  @ViewChild('pdfViewerAutoLoad', { static: false }) pdfViewerAutoLoad: PdfJsViewerComponent
  ShowSpinner: any = false;
  ShowSpinnerTwo: any = false;
  ShowSpinner3: any = false;
  selectAll: boolean = false;
    ReceiptsStatus: any;
    StatementStatus: any;
    filteredAccounts: any;
    filteredAccounts_Recipts: any;
  Base64orHTML: any;
  Pagenumber2: number;
  recordStatus: any;
  rpRecordStatus: boolean = true;
  sfalRecordStatus: boolean = true;
  balRecordStatus: boolean = true;
  sofaRecordStatus: boolean = true;
  AP_Details: any;
  loading: boolean = false;
  apFinalised: boolean = false
  Account_Type: string | null;
  SubmissionStatus: any;
  ReportType: any;
  constructor(private router: Router, private msgService: MessageServiceService, public dialog: MatDialog, public datashare: BasicInformationDataShareService, private datasharenotes: NotesDatashareService, private emailConfigService: Email_Configuration_Service,
    public Charities_Service: CharitiesService, private apiservice: FinalAccountsapiService, private Submissionsapiservice: SubmissionsapiService, private _UsermanagementService: UsermanagementService, private apiservicemail: BalanceSheetapiService,
    private sharedService: CharityDataShareServiceService, private Notedatashare: NotesDatashareService, private fb: FormBuilder, ) {
    this.GetUserAccess()
    
    this.mandatorycount = localStorage.getItem('ReportType_Method') == 'Auditor' ? 6 : 5
    this.Account_Type = localStorage.getItem('account_Type')


  }

  ngOnInit(): void {
    debugger
    this.loading = true
    this.CreateApprovalForm()
    this.sharedService.finalStatus$.subscribe((value: any) => {
      this.apFinalised = value != '' && value == 'Completed'
      if (this.apFinalised) {
        this.ApprovalForm.get('approvalName')?.disable();
        this.ApprovalForm.get('approvalDate')?.disable();
      } else {
        this.ApprovalForm.get('approvalName')?.enable();
        this.ApprovalForm.get('approvalDate')?.enable();
      }
      this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
    })
    this.accounting_Method = localStorage.getItem('accounting_Method') != '' ? localStorage.getItem('accounting_Method') : ''
    this.CreateCheckboxform()
    this.Getcharitydetails()
    this.datasharenotes.isdirty$.subscribe(value => {
      this.isdirty = value
    })
    this.sharedService.ReportTypeMethod$.subscribe(value => {
      this.ReportType = value
    });
    this.editor1 = new Editor();
    this.createAccountsTemplate()
    this.CreateApprovalForm()
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    const input = localStorage.getItem('financial_Year')||'';
    const startDateStr = input.split('To')[0].trim();
    this.startDate = moment(startDateStr);
    this.apiservice.GetTrustees(charityId).subscribe((data: any) => {
      debugger
      this.trustee=data.entity
    })
    
    this.Getbasicinformation()
    this.editor = new Editor()
  
    this.apiservice.GetFinalNotes(period).subscribe((data:any) => {
      debugger
      if (this.Account_Type == 'Amended' && data.finalAccounts1&& !data.finalAccounts1.find((p: any) => p.note === "Note30")) {
        var note30 = { accountName: 'Note30', accStatus: 'Incompleted', note: 'Note30' }
        data.finalAccounts1.push(note30)

      }
      this.BalanceSheetStatus = data.finalAccounts.find((item: any) => item.accountName == 'Balance Sheet')?.accStatus
      this.TrailBalanceStatus = data.finalAccounts.find((item: any) => item.accountName == 'Trial Balance')?.accStatus
      this.SOFAStatus = data.finalAccounts.find((item: any) => item.accountName == 'Statement of Financial Activities')?.accStatus
      this.ReceiptsStatus = data.finalAccounts.find((item: any) => item.accountName == 'Receipts and Payments')?.accStatus
      this.StatementStatus = data.finalAccounts.find((item: any) => item.accountName == 'Statement of Assets and Liabilities')?.accStatus
      this.TrusteeAnnualReportStatus = data.finalAccounts.find((item: any) => item.accountName == 'Trustees Annual Report')?.accStatus
      //alert(this.TrusteeAnnualReportStatus + 'TAR')
      this.AuditorStatus = data.finalAccounts.find((item: any) => item.accountName == 'Auditor')?.accStatus
      this.IndependentExaminationStatus = data.finalAccounts.find((item: any) => item.accountName == 'Independent Examination')?.accStatus
      if (this.IndependentExaminationStatus == 'Incompleted') {
        this.exportForm.controls["independentExaminersReport"].disable()
        this.exportForm.controls["independentExaminersReport"].setValue(false);
      } else {
        this.exportForm.controls["independentExaminersReport"].enable()
      }
      if (this.AuditorStatus == 'Incompleted') {
        this.exportForm.controls["auditorsReport"].disable()
        this.exportForm.controls["auditorsReport"].setValue(false);
      } else {
        this.exportForm.controls["auditorsReport"].enable()
      }
      if (this.SOFAStatus == 'Incompleted') {
        this.exportForm.controls["statementOfFinancialActivities"].disable()
        this.exportForm.controls["statementOfFinancialActivities"].setValue(false);
      } else {
        this.exportForm.controls["statementOfFinancialActivities"].enable()
      }
      if (this.BalanceSheetStatus == 'Incompleted') {
        this.exportForm.controls["balanceSheet"].disable()
        this.exportForm.controls["balanceSheet"].setValue(false);
      } else {
        this.exportForm.controls["balanceSheet"].enable()
      }
      if (this.ReceiptsStatus == 'Incompleted') {
        this.exportForm.controls["receiptsandPayments"].disable()
        this.exportForm.controls["receiptsandPayments"].setValue(false);
      } else {
        this.exportForm.controls["receiptsandPayments"].enable()
      }
      if (this.StatementStatus == 'Incompleted') {
        this.exportForm.controls["statementofAssetsandLiabilities"].disable()
        this.exportForm.controls["statementofAssetsandLiabilities"].setValue(false);
      } else {
        this.exportForm.controls["statementofAssetsandLiabilities"].enable()
      }
      this.StatementofTrusteesResponsibility = data.finalAccounts.find((item: any) => item.accountName == 'Statement of Trustees’ Responsibility')?.accStatus
      if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
        if (localStorage.getItem('ReportType_Method') == 'Independent Examiner') {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Receipts and Payments',
                'Statement of Assets and Liabilities',
                'Independent Examination'
              ].includes(item.accountName)
            );
        }
        else {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Receipts and Payments',
                'Statement of Assets and Liabilities',
                'Auditor',
                'Statement of Trustees’ Responsibility',
                'Trustees Annual Report'
              ].includes(item.accountName)
            );
        }
        }
      else {
        if (localStorage.getItem('ReportType_Method') == 'Independent Examiner') {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Balance Sheet',
                'Statement of Financial Activities',
                'Independent Examination',
              ].includes(item.accountName)
            );
        }
        else {
          this.filteredAccounts = data.finalAccounts
            .filter((item: any) =>
              item.accStatus === 'Completed' &&
              [
                'Trial Balance',
                'Balance Sheet',
                'Statement of Financial Activities',
                'Auditor',
                'Statement of Trustees’ Responsibility',
                'Trustees Annual Report'
              ].includes(item.accountName)
            );
        }
      }
      this.progress = this.filteredAccounts?.length
      if (data.finalAccounts1 != null) {
        debugger
        var Fullnamenotes = [
          { code: 'Note1', name: 'General Information' },
          { code: 'Note2', name: ' Accounting Polices' },
          { code: 'Note3', name: 'Analysis of Income' },
          { code: 'Note4', name: 'Analysis of Receipts of Government Grants' },
          { code: 'Note5', name: 'Donated Goods, Facilities and Services' },
          { code: 'Note6', name: 'Analysis of Expenditure' },
          { code: 'Note7', name: 'Extraordinary Items' },
          { code: 'Note8', name: 'Funds Received as Agent' },
          { code: 'Note9', name: 'Support Costs' },
          { code: 'Note10', name: 'Fees for examination of the accounts' },
          { code: 'Note11', name: 'Paid Employees' },
          { code: 'Note12', name: 'Pension Scheme' },
          { code: 'Note13', name: 'Grantmaking' },
          { code: 'Note14', name: 'Tangible Fixed Assets' },
          { code: 'Note15', name: 'Intangible Assets' },
          { code: 'Note16', name: 'Heritage Assets' },
          { code: 'Note17', name: 'Investment Assets' },
          { code: 'Note18', name: 'Stocks' },
          { code: 'Note19', name: 'Debtors and Prepayments' },
          { code: 'Note20', name: 'Creditors and Accruals' },
          { code: 'Note21', name: 'Provisions for Liabilities and Charges' },
          { code: 'Note22', name: 'Disclosures for Debtors & Creditors' },
          { code: 'Note23', name: 'Contingent Liabilities and Contingent Assets' },
          { code: 'Note24', name: 'Cash and Cash equivalents' },
          { code: 'Note25', name: 'Fair Value of Assets and Liabilities' },
          { code: 'Note26', name: 'Events after the end of the reporting period' },
          { code: 'Note27', name: 'Charity Funds' },
          { code: 'Note28', name: 'Transactions with Trustees and Related Parties' },
          { code: 'Note29', name: 'Additional Disclosures' },
          { code: 'Note30', name: 'Revised Statements' },
        ]

        this.notesArray = data.finalAccounts1.filter((item: any) => item.accStatus == "Incompleted")
        this.notesArray = this.notesArray.sort((a: any, b: any) => {
          const numA = parseInt(a.note.replace(/\D/g, '')) || 0;
          const numB = parseInt(b.note.replace(/\D/g, '')) || 0;
          return numA - numB;
         
        });

        this.notesArray = this.notesArray.map((item: any) => {

          item.noteName = null;
          const match = Fullnamenotes.find(fn => fn.code === item.note);

          return {
            ...item, noteName: match ? match.name : item.note
          };
        });


        
        this.notecompleted = data.finalAccounts1.some((item: any) => item.accStatus == "Incompleted");

        
        if (!this.notecompleted) {
          this.progress += 1;
        }

        
        //this.trusteecompleted = this.TrusteeAnnualReportStatus == "Completed";
        //if (this.trusteecompleted) {  
        //  this.progress += 1;
        //}

       
        //this.statementoftrusteecompleted = this.StatementofTrusteesResponsibility == "Completed";
        //if (this.statementoftrusteecompleted) {
        //  this.progress += 1;
        //}


        //this.notecompleted = data.finalAccounts1.some((item: any) => item.accStatus == "Incompleted")
        //if (! this.notecompleted) {
        //  this.progress+=1
        //}
        //this.trusteecompleted = this.TrusteeAnnualReportStatus == "Completed";
        //if (!this.trusteecompleted) {
        //  this.progress+=1
        //}
        //this.statementoftrusteecompleted = this.StatementofTrusteesResponsibility == "Completed";
        //if (!this.statementoftrusteecompleted) {
        //  this.progress += 1
        //}
      }
      else {
        this.notecompleted=true
        this.trusteecompleted=true
        this.statementoftrusteecompleted=true
      }
      this.progress = this.progress == 0 ? 1 : this.progress
      this.progress = (this.progress / this.mandatorycount) * 100
      console.log('Final progress:', this.progress);
      if (data.recordStatus != null) {
        this.recordStatus = data.recordStatus
        if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
          debugger
          if (this.recordStatus[0]?.accountName == 'ReceiptsAndPayments' && this.recordStatus[0]?.accStatus == 'Record Not Found') {
            this.exportForm.get('receiptsandPayments')?.setValue(false);
            this.exportForm.get('receiptsandPayments')?.disable();
            this.rpRecordStatus = false;

          }
          if (this.recordStatus[1]?.accountName == 'Statement_of_Assets_liabilities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
            this.exportForm.get('statementofAssetsandLiabilities')?.setValue(false);
            this.exportForm.get('statementofAssetsandLiabilities')?.disable();
            this.sfalRecordStatus = false;
          }
        }
        else {
          if (this.recordStatus[0]?.accountName == 'Balance Sheet' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
            this.exportForm.get('balanceSheet')?.setValue(false);
            this.exportForm.get('balanceSheet')?.disable();
            this.balRecordStatus = false;
          }
          if (this.recordStatus[1]?.accountName == 'Statement of Financial Activities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
            this.exportForm.get('statementOfFinancialActivities')?.setValue(false);
            this.exportForm.get('statementOfFinancialActivities')?.disable();
            this.sofaRecordStatus = false;
          }
        }
      }
      if (data.approvalDetails) {
        //this.ApprovalForm.patchValue(data.approvalDetails)
        if ((this.accounting_Method != 'Accruals (FRS 102 SORP)')) {
          var res = JSON.parse(data?.approvalDetails?.approvalName || '[]');
          this.ApprovalForm.get('approvalName')?.setValue(Array.isArray(res)?res:[]);
        }
        else {
          this.ApprovalForm.get('approvalName')?.setValue(Number(data?.approvalDetails?.approvalName));
        }
        this.ApprovalForm.get('approvalDate')?.setValue(data.approvalDetails?.approvalDate)
        if (this.apFinalised) {
          this.ApprovalForm.get('approvalName')?.disable();
          this.ApprovalForm.get('approvalDate')?.disable();
        } else {
          this.ApprovalForm.get('approvalName')?.enable();
          this.ApprovalForm.get('approvalDate')?.enable();
        }
        this.Descriptionstring = data.approvalDetails?.description ? data.approvalDetails?.description : ""
        this.initialContent = data.approvalDetails?.description ? data.approvalDetails?.description : ""
      }
      else {
        this.Descriptionstring = this.statement
        this.initialContent = this.statement
       
      }
      this.loading = false
    })

    this.exportForm.valueChanges.subscribe(() => {
      const filteredControls = this.getFilteredControls();
      const allSelected = filteredControls.every(([_, control]) => control.value === true);
      this.selectAll = allSelected;
    });
   

  }
isOptionDisabled() {
  const selected: string[] = this.ApprovalForm.get('approvalName')?.value || [];
  if (selected.length > 2 ) {
    this.ApprovalForm.get('approvalName')?.setErrors({maxlimit:true})
  }
  
}

  CreateApprovalForm() {
    this.ApprovalForm = this.fb.group({
      approvalName: [null],
      approvalDate: [null],
      description: [null]

    });
  }
  notenavigation(url: any) {
    debugger
    this.Notedatashare.setisActive(1);
    this.Notedatashare.setSubTab(1)
    this.router.navigate([url])

  }
  private stripHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent?.trim() || '';
  }
  backToCharityOverView() {
    debugger
    localStorage.setItem('isFromBasicInfo', 'true')
    this.router.navigate(['/charity']);

  }

  //openPreview(template: any) {
  //  debugger
  //  let dialogRef = this.dialog.open(template, { width: '50%', maxWidth: '100%', disableClose: true });
  //  this.ExportasPDFandIXBRL('ExportasPDF', 'ForPDFviwer')
  //}



  closeModalPreview() {
    this.dialog.closeAll();
  }


  GetUserAccess() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
    });
  }
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  Accountsform: FormGroup
  createAccountsTemplate() {
    this.Accountsform = this.fb.group({
      emailTemplateId: [0],
      emailType: ['Accounts'],
      from: [{ value: this.RetriveEmailConfigdata?.senderEmail, disabled: true }],
      cc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      bcc: ['', [Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]],
      ccCheckbox: [false],
      subject: ['', Validators.required],
      Body: [''],
      charityID: [+localStorage.getItem('charityId')!],
      financialPeriodsID: [+localStorage.getItem('currentPeriod')!],
      createdby: [0],
      modifiedby: [0],
      centralUserId: [+localStorage.getItem('CentralUserId')!],
      userId: [+localStorage.getItem('CurrentuserID')!],
      fund_Tracking: [localStorage.getItem('fund_Tracking') === 'true'],
      //fund_Tracking:[+localStorage.getItem('fund_Tracking')!],
      to: [
        '',
        [Validators.required, Validators.pattern(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/)]
      ],
    });
    this.ifCCorBCCAccountsform = false
    this.Accountsform.get('Body')?.valueChanges.subscribe(value => {

      const plainText = value?.replace(/<[^>]*>/g, '') || '';
      if (plainText.length > 2500) {
        const trimmedText = plainText.substring(0, 2500);
        const safeHtml = `<p>${trimmedText}</p>`;
        this.Accountsform.get('Body')?.setValue(safeHtml, { emitEvent: false });
      }
    });

  }

  sendMailTemplate(emailtemplate: any) {
    this.RetriveEmailConfig(emailtemplate)
    //this.dialog.open(emailtemplate, {
    //  width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: false
    //});
  }
  cenceltemplate() {
    debugger
    if (this.Accountsform.dirty) {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.datasharenotes.setisdirty(false)
          this.isdirty = false
          this.Accountsform.markAsUntouched()
          this.Accountsform.markAsPristine()
          this.Accountsform.controls['to'].markAsUntouched()
          this.dialog.closeAll()
        }
        else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return
        }

      })

    }
    else {
      this.Accountsform.markAsUntouched()
      this.Accountsform.markAsPristine()
      this.Accountsform.controls['to'].markAsUntouched()
      this.dialog.closeAll()

    }

  }

  sendmail() {
    debugger
    if (this.Accountsform.valid) {
      this.apiservicemail.sentmail(this.Accountsform.getRawValue()).subscribe((Data: any) => {
        debugger
        var reponse = Data;
        if (reponse == "TrialBalanceEmailResponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "OK",

            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        }
        else if (reponse == "TrialBalanceTemplateresponse") {
          Swal.fire({
            html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Please complete the Preference</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Preference need to be done.',
            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "Ok",
            allowOutsideClick: false
          }).then((result) => {
            if (result.value) {
            } else {
              return
            }
          })
        } else if (reponse == "mail_sent") {
          debugger
          this.dialog.closeAll()
          this.msgService.showToastMessage("success", "Mail sent successfully");
        }
      })
    } else {


      this.Accountsform.markAllAsTouched()
    }
  }


  RetriveEmailConfig(emailtemplate?: any) {
    debugger
    var Central_UserId = parseInt(localStorage.getItem('CentralUserId') || '0');
    this.emailConfigService.RetriveEmailConfig(Central_UserId).subscribe((data: BaseEntityModel<Email_Configuration_Model>) => {
      if (data.status === 0) {
        if (data.message == "Successfully, retrieved email server info") {
          if (data.entity != null && data.entity.length > 0) {
            this.RetriveEmailConfigdata = data.entity[0];
            this.Accountsform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
            this.dialog.open(emailtemplate, {
              width: '50%', maxWidth: '100%', maxHeight: 'auto', height: 'auto', disableClose: true
            });
            this.GetEmailTemplate()
          } else {
            Swal.fire({
              html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
              iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
              confirmButtonText: "OK",
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              } else {
                return
              }
            })
            //this.toastr.error(data.message);

          }
        } else {
        }
      } else {
        Swal.fire({
          html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Mail Server details not configured!</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> Please configure Mail Server setting to send an email.',
          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
          confirmButtonText: "OK",
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
          } else {
            return
          }
        })
        //t//his.toastr.error(data.message);
      }
    }, (error: HttpErrorResponse) => {
      //this.toastr.error(error.statusText);
    })

  }
  isBodyEmpty(formname?: any): boolean {
    const rawHtml = formname.get('Body')?.value || '';
    const strippedText = rawHtml.replace(/<[^>]*>/g, '').trim();
    return strippedText === '';
  }
  ifCCorBCCAccountsform: boolean = false;

  AccountsformmailtoCC() {
    debugger
    this.ifCCorBCCAccountsform = !this.ifCCorBCCAccountsform;
    if (!this.ifCCorBCCAccountsform) {
      this.Accountsform.controls['cc'].reset();
      this.Accountsform.controls['bcc'].reset();
    }
  }
  GetEmailTemplate() {
    debugger;
    this.Charities_Service.GetEmailTemplate(this.Accountsform.controls['centralUserId'].value, this.Accountsform.controls['emailType'].value).subscribe({
      next: (data: any) => {
        debugger;
        if (data.entity != null && data.entity[0].emailTemplateId != null) {
          this.Accountsform.patchValue(data.entity[0])
          this.Accountsform.controls['Body'].setValue(data.entity[0].body)
          this.Accountsform.controls['charityID'].setValue(+localStorage.getItem('charityId')!)
          this.Accountsform.controls['financialPeriodsID'].setValue(+localStorage.getItem('currentPeriod')!)
          this.Accountsform.controls['fund_Tracking'].setValue(localStorage.getItem('fund_Tracking') === 'true')
          this.ifCCorBCCAccountsform = data.entity[0].ccCheckbox;
        }
        else {
          this.createAccountsTemplate()
        }
        this.Accountsform.controls['from'].setValue(this.RetriveEmailConfigdata?.senderEmail)
        this.Accountsform.markAsPristine()
      },
      error: (err) => {
        console.error('Error fetching GetEmailTemplate details:', err);
      }
    });
  }


  ngOnDestroy(): void {

    this.editor.destroy();
  }
  setdefault() {
    //this.editor.setContent('')
    this.editor.setContent(this.statement)
  }
  Getbasicinformation() { 
    debugger
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    /*alert('hitted')*/
    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.accounting_Method = data[0].accounting_Method
      this.report_Type = data[0].report_Type
      this.Account_Type = data[0].account_Type
      this.AP_Details = data[0]
    
    })
  }

  //toolbar: Toolbar = [
  //  ['bold', 'italic'],
  //  ['underline'],
  //  ['ordered_list', 'bullet_list'],
  //  [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
  //  ['text_color', 'background_color'],
  //  ['align_left', 'align_center', 'align_right', 'align_justify'],
  //];

  statement: string = `<p>The Charity was entitled to exemption from audit under section 477 of the Companies Act 2006.</p><p>The members have not required the company to obtain an audit in accordance with section 476 of the Companies Act 2006.</p><p>The trustees acknowledge their responsibilities for complying with the requirements of the Companies Act with respect to accounting records and the preparation of accounts.</p><p>These accounts have been prepared in accordance with the provisions applicable to small charities, subject to the small companies’ regime and in accordance with FRS 102 SORP.</p>`

  MAX_LENGTH = 2500;
  trim(html: string, name: any): void {
    debugger
    const plainText = this.stripHtmlTags(html);
    const trimmedText = plainText.slice(0, this.MAX_LENGTH).trimEnd();

    // Convert trimmed plain text back to HTML preserving spaces and line breaks
    // const trimmedHtml = this.plainTextToHtmlWithSpaces(trimmedText);

    // Update UI & model with trimmed HTML
    this.setEditorContentByName( trimmedText);
    this.updateTarDetails( trimmedText);

  }

  handleEditorInput(html: string): void {
    if (html != this.initialContent) {
      this.isdirty = true;

      this.Notedatashare.setisdirty(true)

    }
    const plainText = this.stripHtmlTags(html);

    if (plainText.length <= this.MAX_LENGTH) {
      this.previousValidHtml = html;
      this.updateTarDetails( html);
    } else {
      // Trim the plain text to MAX_LENGTH
      const trimmedText = plainText.slice(0, this.MAX_LENGTH);

      // Convert trimmed plain text back to HTML preserving spaces and line breaks
      const trimmedHtml = this.plainTextToHtmlWithSpaces(trimmedText);

      // Update UI & model with trimmed HTML
      this.setEditorContentByName( trimmedHtml);
      this.updateTarDetails( trimmedHtml);
    }
  }

  updateTarDetails( html: string) {
   
  }
  setEditorContentByName( html: string) {
        this.editor.setContent(html);
  }

  stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  // Convert plain text to HTML with spaces and line breaks preserved
  plainTextToHtmlWithSpaces(text: string): string {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/  /g, " &nbsp;")      // preserve multiple spaces
      .replace(/\n/g, "<br>");        // preserve line breaks
  }

  checkdate(event: any) {
    debugger
    const baseDate = moment('01/01/1753', 'DD/MM/YYYY');     // 1st Jan 1753
    const compareDate = moment(event.target.value, 'DD/MM/YYYY');
    if (!event.target.value) {
      this.ApprovalForm.get('approvalDate')?.markAsTouched()
      this.ApprovalForm.get('approvalDate')?.setErrors({ required: true })
    }
    else if (!(moment(event.target.value, 'DD/MM/YYYY', true).isValid())) {
      this.ApprovalForm.get('approvalDate')?.markAsTouched()
      this.ApprovalForm.get('approvalDate')?.setErrors({ Invalid: true })
    }
    else if (compareDate < this.startDate || compareDate > this.today) {
      this.ApprovalForm.get('approvalDate')?.markAsTouched()
      this.ApprovalForm.get('approvalDate')?.setErrors({ Dateexceed: true })
    }
  }

  FinaliseandSubmitAccounts() {
    if (!this.validateBeforeFinalise()) {
      return;
    }
    //debugger
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px; padding-right: 30px !important;">By finalising, you are confirming these accounts are complete and the period will be locked and ready to submit. Do you want to continue?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.save("FinaliseandSubmitAccounts");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }


  save(final: any) {
    debugger
    

    if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
      this.isOptionDisabled();
    }
    if (this.Descriptionstring == "<p></p>" || this.Descriptionstring=="") {
       Swal.fire({
         html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Final Accounts statement is required</p>',
         iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
       })
      return
    }
    if (this.trustee != null) {
      if (this.accounting_Method == 'Accruals (FRS 102 SORP)') {
        var exists: boolean = this.trustee.some((obj: any) => obj.trustee_Id === this.ApprovalForm.get('approvalName')?.value);
      }
      else {
        var ids = new Set(this.ApprovalForm.get('approvalName')?.value);
        var exists: boolean = this.trustee.some((obj: any) => ids.has(obj.trustee_Id));
      }
      if (!exists) {
        this.ApprovalForm.get('approvalName')?.setValue(null);
      }
    }
    else {
      this.ApprovalForm.get('approvalName')?.setValue(null);
    }
    if (!this.ApprovalForm.get('approvalDate')?.getRawValue() || !this.ApprovalForm.get('approvalName')?.getRawValue() || !this.ApprovalForm.valid) {

      const approvalDateControl = this.ApprovalForm.get('approvalDate');
      const approvalDateValue = approvalDateControl?.value
      const approvalDateErrors = approvalDateControl?.errors;

      if (!approvalDateValue && !approvalDateErrors?.['Invalid']) {
        approvalDateControl?.markAsTouched();
        approvalDateControl?.setErrors({ required: true });
      }

      if (!this.ApprovalForm.get('approvalName')?.getRawValue()) {
        this.ApprovalForm.get('approvalName')?.markAsTouched()
        this.ApprovalForm.get('approvalName')?.setErrors({ required: true })
      }
      return
    }
    var uid = localStorage.getItem('CurrentuserID')
    var cid = localStorage.getItem('CentralUserId')
    var fid = localStorage.getItem('currentPeriod')
      var data = this.ApprovalForm.getRawValue()
    var details = new ApprovalDetails(data)
    details.approvalDate = details.approvalDate ? moment(details.approvalDate).format('YYYY-MM-DD') : null
    if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
      details.approvalName = details.approvalName ? JSON.stringify(details.approvalName) : ''
    }
    else {
      details.approvalName = details.approvalName.toString()
    }
    details.description = this.Descriptionstring
    details.centralUserId = cid ? +cid : 0
    details.userId = uid ? +uid : 0
    details.financialPeriodsID = fid ? +fid : 0
    this.Notedatashare.setisdirty(false)
    this.isdirty = false
    this.ApprovalForm.markAsPristine();
      this.apiservice.save(details).subscribe((data: any)=>{
        debugger
        this.sharedService.setFinalStatus('Completed');
        localStorage.setItem('apFinalised', 'Completed')
        if (final == "FinaliseandClose") {
          this.backToCharityOverView();
        }
        else {
          this.router.navigate(['/submissions'])
        }
      })

    
    
  }

  validate() {
    this.Notedatashare.setisdirty(true)
  }
   CanDeactivate(): any {
     debugger
     if (this.ApprovalForm.dirty || this.isdirty ) {
       

      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px; padding-right: 30px !important;"> Are you sure you want to leave this page. <br> Data entered will not be saved.</p>',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          debugger
          this.isdirty = false;
          this.Notedatashare.setisdirty(false)
          return true
        } else {
          localStorage.setItem("currentCharityIDFromSwitch", "");
          return false
        }
      })
     } else {
       this.Notedatashare.setisdirty(false)
      return true
    }
  }


  FinaliseandClose(): any {

    if (!this.validateBeforeFinalise())
    {
      return; 
    }

    Swal.fire({
      html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px; padding-right: 30px !important;">By finalising, you are confirming these accounts are complete and the period will be locked for editing. Do you want to finalise the period?</p>`,
      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No",
      allowOutsideClick: false,
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.save("FinaliseandClose");
      }
      else {}
    })
  }


  Getcharitydetails() { 
    debugger
    let charityID = localStorage.getItem("CharityIdforSubmission")
    if (charityID) {
      this.Charities_Service.EditCharityDetails(charityID).subscribe((data: CharityDetailsModal[]) => {
        debugger
        this.CharityDetails = data
      })
    }
  }

  openExport(templateExport?: any) {
    debugger
    Object.keys(this.exportForm.controls).forEach(key => {
        this.exportForm.get(key)?.setValue(false);
    });
    const filteredControls = this.getFilteredControls();
    filteredControls.forEach(([_, control]) => {
      control.setValue(true);
    });
    if (this.TrusteeAnnualReportStatus == 'Completed' && this.report_Type == 'Auditor') {
      this.exportForm.get('trusteesAnnualReport')?.setValue(true);
      this.exportForm.get('trusteesAnnualReport')?.disable();

    }
    else if (this.TrusteeAnnualReportStatus == 'Completed' && this.report_Type == 'Independent Examiner') {
      this.exportForm.get('trusteesAnnualReport')?.setValue(true);
      this.exportForm.get('trusteesAnnualReport')?.enable();

    }
    if (this.StatementofTrusteesResponsibility == 'Completed') {
      this.exportForm.get('statementofTrusteesResponsibility')?.setValue(true);
    }
    else {
      this.exportForm.get('statementofTrusteesResponsibility')?.setValue(false);
    }
    if (this.recordStatus != null) {
      if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
        if (this.recordStatus[0]?.accountName == 'ReceiptsAndPayments' && this.recordStatus[0]?.accStatus == 'Record Not Found') {
          this.exportForm.get('receiptsandPayments')?.setValue(false);
          this.exportForm.get('receiptsandPayments')?.disable();
          this.rpRecordStatus = false;

        }
        if (this.recordStatus[1]?.accountName == 'Statement_of_Assets_liabilities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
          this.exportForm.get('statementofAssetsandLiabilities')?.setValue(false);
          this.exportForm.get('statementofAssetsandLiabilities')?.disable();
          this.sfalRecordStatus = false;
        }
      }
      else {
        if (this.recordStatus[0]?.accountName == 'Balance Sheet' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
          this.exportForm.get('balanceSheet')?.setValue(false);
          this.exportForm.get('balanceSheet')?.disable();
          this.balRecordStatus = false;
        }
        if (this.recordStatus[1]?.accountName == 'Statement of Financial Activities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
          this.exportForm.get('statementOfFinancialActivities')?.setValue(false);
          this.exportForm.get('statementOfFinancialActivities')?.disable();
          this.sofaRecordStatus = false;
        }
      }
    }
    if (this.notecompleted) {
      this.exportForm.controls["notes"].disable()
      this.exportForm.controls["notes"].setValue(false);
    } else {
      this.exportForm.controls["notes"].enable()
      this.exportForm.controls["notes"].setValue(true);
    }
    if (templateExport) {
      let dialogRef = this.dialog.open(templateExport, {
        width: '40%', maxWidth: '100%', disableClose: true
      });
    }
  }

  CreateCheckboxform() {
    this.exportForm = new FormGroup({
      coverPage: new FormControl(false),
      contentsPage: new FormControl(false),
      referenceandAdministrationDetails: new FormControl(false),
      trusteesAnnualReport: new FormControl(false),
      statementofTrusteesResponsibility: new FormControl(false),
      independentExaminersReport: new FormControl(false),
      auditorsReport: new FormControl(false),
      statementOfFinancialActivities: new FormControl(false),
      balanceSheet: new FormControl(false),
      notes: new FormControl(false),
      receiptsandPayments: new FormControl(false),
      statementofAssetsandLiabilities: new FormControl(false),
      is_ForSubmissions: new FormControl(false),  //important thing this will depend on submissions
      export_Type: new FormControl(null)  
    });
  }
  selectionchange(control: any) {
    debugger
    if (control == 'RP') {
      if (this.recordStatus[0]?.accountName == 'ReceiptsAndPayments' && this.recordStatus[0]?.accStatus == 'Record Not Found') {
        this.exportForm.get('receiptsandPayments')?.setValue(false);
        this.showmsg('Receipts and Payments')
      }
    }
    else if (control == 'SFAL') {
      if (this.recordStatus[1]?.accountName == 'Statement_of_Assets_liabilities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
        this.exportForm.get('statementofAssetsandLiabilities')?.setValue(false);
        this.showmsg('Statement of Assets and Liabilities');
      }
    }
    else if (control == 'BAL') {
      if (this.recordStatus[0]?.accountName == 'Balance Sheet' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
        this.exportForm.get('balanceSheet')?.setValue(false);
        this.showmsg('Balance Sheet')
      }
    }
    else if (control == 'SOFA') {
      if (this.recordStatus[1]?.accountName == 'Statement of Financial Activities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
        this.exportForm.get('statementOfFinancialActivities')?.setValue(false);
        this.showmsg('Statement of Financial Activities')
      }
    }
  }
  showmsg( msg:any) {
    Swal.fire({
      html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px; padding-right: 30px !important;"> There is no data in '+ msg+' Report.</p>',
      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      confirmButtonText: "OK",
      allowOutsideClick: false
    })
  }

  toggleAll(event: MatCheckboxChange): void {
    const isChecked = event.checked;
    const filteredControls = this.getFilteredControls();

    filteredControls.forEach(([_, control]) => {
      control.setValue(isChecked);
    });
    //if (this.recordStatus != null) {
    //  if (this.accounting_Method != 'Accruals (FRS 102 SORP)') {
    //    if (this.recordStatus[0]?.accountName == 'ReceiptsAndPayments' && this.recordStatus[0]?.accStatus == 'Record Not Found') {
    //      this.exportForm.get('receiptsandPayments')?.setValue(false);
    //    }
    //    if (this.recordStatus[1]?.accountName == 'Statement_of_Assets_liabilities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
    //      this.exportForm.get('statementofAssetsandLiabilities')?.setValue(false);
    //    }
    //  }
    //  else {
    //    if (this.recordStatus[0]?.accountName == 'Balance Sheet' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
    //      this.exportForm.get('balanceSheet')?.setValue(false);
    //    }
    //    if (this.recordStatus[1]?.accountName == 'Statement of Financial Activities' && this.recordStatus[1]?.accStatus == 'Record Not Found') {
    //      this.exportForm.get('statementOfFinancialActivities')?.setValue(false);
    //    }
    //  }
    //}
  }


  // Helper method to get filtered enabled controls
  getFilteredControls(): [string, AbstractControl][] {

    // Get all enabled controls
    const enabledControls = Object.entries(this.exportForm.controls)
      .filter(([_, control]) => !control.disabled);

    let filteredControls: [string, AbstractControl][] = [];

    if (this.accounting_Method === 'Accruals (FRS 102 SORP)') {
        // Base exclusions for accruals method
        const baseExclusions = ['is_ForSubmissions', 'export_Type', 'receiptsandPayments', 'statementofAssetsandLiabilities'];


      
      if (this.TrusteeAnnualReportStatus !== 'Completed' || this.StatementofTrusteesResponsibility !== 'Completed') {
        baseExclusions.push('trusteesAnnualReport');
        baseExclusions.push('statementofTrusteesResponsibility');
      }

      
        //// Apply Trustee Annual Report condition
        //if (this.TrusteeAnnualReportStatus !== 'Completed') {
        //  baseExclusions.push('trusteesAnnualReport');
        //}

        //// Apply Statement of Trustees Responsibility condition
        //if (this.StatementofTrusteesResponsibility !== 'Completed') {
        //  baseExclusions.push('statementofTrusteesResponsibility');
        //}

        // Apply Report Type condition
        if (this.report_Type === 'Auditor') {
          baseExclusions.push('independentExaminersReport');
        } else {
          baseExclusions.push('auditorsReport');
        }

        filteredControls = enabledControls.filter(([key]) => !baseExclusions.includes(key));

    } else {
      // Receipts and payments method
      const baseExclusions = ['is_ForSubmissions', 'export_Type', 'statementOfFinancialActivities', 'balanceSheet'];

      //if (this.TrusteeAnnualReportStatus !== 'Completed') {
      //  baseExclusions.push('trusteesAnnualReport');
      //}

      //if (this.StatementofTrusteesResponsibility !== 'Completed') {
      //  baseExclusions.push('statementofTrusteesResponsibility');
      //}

      if (this.report_Type === 'Auditor') {
        baseExclusions.push('independentExaminersReport');
      } else {
        baseExclusions.push('auditorsReport');
      }

      filteredControls = enabledControls.filter(([key]) => !baseExclusions.includes(key));
    }

    return filteredControls;
  }

  //isAnySectionSelected(): boolean {
  //  const excludedKeys = ['is_ForSubmissions', 'export_Type'];
  //  return Object.entries(this.exportForm.value)
  //    .filter(([key]) => !excludedKeys.includes(key))
  //    .some(([, value]) => value === true);
  //}
  isAnySectionSelected(): boolean {
    const excludedKeys = ['is_ForSubmissions', 'export_Type'];
    const coverAndContentKeys = ['coverPage', 'contentsPage']; // <-- adjust names to match your form control keys

    const formValues = this.exportForm.value;

    // All selected keys (true checkboxes)
    const selectedKeys = Object.entries(formValues)
      .filter(([key, value]) => !excludedKeys.includes(key) && value === true)
      .map(([key]) => key);

    // If no selection at all → disable
    if (selectedKeys.length === 0) {
      return false;
    }

    // If ONLY coverPage and/or contentPage are selected → disable
    const onlyCoverContentSelected = selectedKeys.every(key =>
      coverAndContentKeys.includes(key)
    );

    return !onlyCoverContentSelected;
  }


  ExportasPDFandIXBRL(ExportType?: any, Is_PDFviwer?: any, template?:any,isfrom?:any) {  
    debugger
    this.ShowSpinner = true;
    if (Is_PDFviwer == 'Spinnerthree') {
      this.ShowSpinner3 = true;
    } else {
      this.ShowSpinner3 = false;
    }
    var Period = this.AP_Details.current_AP_End_Date.slice(0, 10).split('-')
    var FileName = `${this.CharityDetails[0].charity_Name}_${Period[0]}${Period[1]}${Period[2]}`
    if (isfrom === 'Preview') {
      this.openExport()
     
      if (Is_PDFviwer === 'ForPDFviwer') {
        this.ShowSpinnerTwo = true;
      }
    }

    this.exportForm.controls["is_ForSubmissions"].setValue(false);
    this.exportForm.controls["export_Type"].setValue(ExportType);
    let Selectedcheckboxes = this.exportForm.getRawValue()
    const formData: FormData = new FormData();
    // Append checkbox selections as JSON string
    formData.append('SelectedData', JSON.stringify(Selectedcheckboxes));
    formData.append('CompanyRegistrationNumber', this.CharityDetails[0].charity_Registration_Number);
    formData.append('CompanyName', this.CharityDetails[0].charity_Name);
    formData.append('APPeriodCoveredTo', '01/07/2024'); // date as string
    formData.append('ContactName', this.CharityDetails[0].first_Name_Detail);
    formData.append('ContactNumber', this.CharityDetails[0].telephone_Number);
    formData.append('CharityReferenceNumber', this.CharityDetails[0].company_Reference_Number);
    formData.append('jurisdiction_Charity', this.CharityDetails[0].jurisdiction_Charity);
    formData.append('ReportType', this.ReportType);
    formData.append('APPeriodId', localStorage.getItem('currentPeriod') || '');
    formData.append('CompanyID', this.CharityDetails[0].charityID);

    const userId = parseInt(localStorage.getItem('userID') || '0', 10);
    formData.append('UserID', userId.toString());

    // Optional fields - pass empty string to avoid null binding issues
    formData.append('Actiontype', '');
    formData.append('AccountTemplateId', '123456'); // optional int
    formData.append('PackageReference', '');
    formData.append('submissionDate', '');
    formData.append('DateSigned', '');

    // Optional fields not in original post, but required by model
    formData.append('version', '');
    formData.append('submissionstatus', '');
    formData.append('TransactionID', '');
    formData.append('Flag', '');
    formData.append('FBI_URLToUpload', '');
    formData.append('FBI_XMLToUpload', '');
    formData.append('FBIStatus', '');
    formData.append('SaveCredentials', '');
    formData.append('FBI_Master_ID', '');
    formData.append('FBI_History_ID', '');
    formData.append('RequestType', '');
    formData.append('URL', '');
    formData.append('ResponseType', '');
    formData.append('ResponseTimeStamp', '');
    formData.append('ResponseText', '');
    formData.append('PeriodEnd', '');
    formData.append('FBI_History_JSON', '');
    formData.append('FBI_History_JSON_ResponseText', '');
    formData.append('CreatedBy', '');
    formData.append('TaxYear', '');
    formData.append('FBIResponce', '');
    formData.append('APPeriodCoveredFrom', '');
    formData.append('CreatedDate', '');
    this.Submissionsapiservice.GetSelectedReports(formData).subscribe(async (data) => {
      debugger
      if (data) {
        debugger
        this.ShowSpinner = false;
        var parsedData = JSON.parse(data)
        var Base64 = parsedData["base64string"]
        this.Base64orHTML = Base64.xmldata

        if (Is_PDFviwer == 'ForPDFviwer') {
          this.ShowSpinnerTwo = false;
          this.dialog.open(template, { width: '60%', maxWidth: '100%', height: '90%', disableClose: true }); //For opening PDFviewer
          //  const byteCharacters = atob(this.Base64orHTML);
          //  const byteNumbers = new Array(byteCharacters.length);

          //  for (let i = 0; i < byteCharacters.length; i++) {
          //    byteNumbers[i] = byteCharacters.charCodeAt(i);
          //  }
          //  const byteArray = new Uint8Array(byteNumbers);
          //  const blob = new Blob([byteArray], { type: 'application/pdf' });
          //  var vamshi = URL.createObjectURL(blob);

          // setTimeout(() => {
          //  // Only access pdfViewerAutoLoad if printing
          //  if (this.pdfViewerAutoLoad) {
          //    this.pdfViewerAutoLoad.pdfSrc = vamshi;
          //    this.pdfViewerAutoLoad.downloadFileName = 'Submissions_Report';
          //    this.pdfViewerAutoLoad.refresh();
          //  }
          //}, 1000);
        var htmlFile = 'data:application/pdf;base64,' + this.Base64orHTML
        this.Submissionsapiservice.downloadFile(htmlFile).subscribe(
          (res:any) => {
            setTimeout(() => {
              if (this.pdfViewerAutoLoad) {
                this.pdfViewerAutoLoad.pdfSrc = res;
                this.pdfViewerAutoLoad.downloadFileName = FileName;
                this.pdfViewerAutoLoad.refresh();
              }
            }, 1000); //1000 milli seconds(1 sec)

          })
       } else {
          if (ExportType == 'ExportasPDF') {
            // Convert base64 string to byte array
            const byteCharacters = atob(this.Base64orHTML);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${FileName}.pdf`;
            link.click();
            // Optional: clean up
            window.URL.revokeObjectURL(link.href);
           // this.closeModalPreview() 
          }
          else {
            this.ShowSpinner3 = false;
            var blob = new Blob([this.Base64orHTML], { type: "text/html" });          
            var url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${FileName}.html`;
            link.click();
           // this.closeModalPreview()
          }
       }
      }
    })
  }

  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
            this.Account_Type = 'Amended'
            this.ngOnInit()

          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"><b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }
  private validateBeforeFinalise(): boolean {
    let isValid = true;
    if (!this.Descriptionstring || this.Descriptionstring === '<p></p>') {
      Swal.fire({
        text: 'Final Accounts statement is required',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      isValid = false;
    }
   


    if (!this.ApprovalForm.get('approvalDate')?.value) {
      this.ApprovalForm.get('approvalDate')?.markAsTouched();
      this.ApprovalForm.get('approvalDate')?.setErrors({ required: true });
      isValid = false;
    }


    if (!this.ApprovalForm.get('approvalName')?.value) {
      this.ApprovalForm.get('approvalName')?.markAsTouched();
      this.ApprovalForm.get('approvalName')?.setErrors({ required: true });
      isValid = false;
    }

   
  
    if (this.ApprovalForm.invalid) {
      this.ApprovalForm.markAllAsTouched();
      isValid = false;
    } 
    return isValid;;

  }
}

